<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo Consultor na parte cadastro de Status do Menu Consultor  ==================------->

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formCadastro.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/1 w-full">
          <div>Banner (1900 x 450)</div>
          <center v-if="formCadastro.banner">
            <img
              :src="formCadastro.banner"
              width="100%"
              style="max-width: 190px"
            />
          </center>
          <input
            id="fileUpload2"
            type="file"
            hidden
            v-on:change="selecionaBanner"
          />
          <vs-button
            color="warning"
            type="border"
            class="mr-3 text-center"
            @click.stop.prevent="chooseFiles2()"
          >
            Escolher uma Imagem
            <feather-icon icon="UploadIcon" class="ml-2" />
            <Br />
            <vs-chip v-if="banner" class="mt-3">
              <vs-avatar icon-pack="feather" icon="icon-file" />
              <span>{{ banner }}</span>
            </vs-chip>
          </vs-button>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/1 w-full">
          <div>Banner Mobile (390 x 450)</div>
          <center v-if="formCadastro.bannerMobile">
            <img
              :src="formCadastro.bannerMobile"
              width="100%"
              style="max-width: 190px"
            />
          </center>
          <input
            id="fileUpload3"
            type="file"
            hidden
            v-on:change="selecionaBannerMobile"
          />
          <vs-button
            color="warning"
            type="border"
            class="mr-3 text-center"
            @click.stop.prevent="chooseFiles3()"
          >
            Escolher uma Imagem
            <feather-icon icon="UploadIcon" class="ml-2" />
            <Br />
            <vs-chip v-if="bannerMobile" class="mt-3">
              <vs-avatar icon-pack="feather" icon="icon-file" />
              <span>{{ bannerMobile }}</span>
            </vs-chip>
          </vs-button>
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/1 w-full">
          <span>Link</span>
          <vs-input
            type="Link"
            class="w-full"
            name="Link"
            id="Link"
            v-model="formCadastro.link"
            :state="
              utilsList.validateState(this.veeFields, this.veeErrors, 'Link')
            "
            :danger="
              !utilsList.validateState(this.veeFields, this.veeErrors, 'Link')
            "
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <span>Ordenação</span>
          <vs-input
            class="w-full"
            name="Ordenação"
            id="Ordenação"
            type="number"
            v-model="formCadastro.ordenacao"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Ordenação'
              )
            "
            :danger="
              !utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Ordenação'
              )
            "
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idBanner == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from "../../../../locale";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import vSelect from "vue-select";
import service from "../../../../services";
import BotaoSubmit from "../../../../components/BotaoSubmit";
import utilsList from "../../../../utils/list";
import cpfCnpj from "../../../../services/cpfCnpj";
import dataFunctions from "../../../../utils/dateConversion";
import imageFunctions from "../../../../utils/imageFunctions";
export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    contadorRender: {
      type: Number,
    },
  },
  watch: {
    dados(value) {
      this.preencheForm();
    },
    contadorRender(value) {
      this.preencheForm();
    },
  },
  data() {
    return {
      utilsList,
      decoded: utilsList.buscaToken(),
      aguardeCadastro: false,
      languages: lang,
      funcoesValicao: null,
      tiposPagamentos: [],
      files: new FormData(),
      banner: null,
      bannerMobile: null,
      temaCor: {},
      distribuidores: [],
      produtos: [],
      tiposBanner: ["Ecommerce", "App"],
      formCadastro: {
        idBanner: null,
        status: true,
        banner: null,
        bannerMobile: null,
        link: "http://",
        ordenacao: null,
      },
    };
  },
  methods: {
    chooseFiles2() {
      document.getElementById("fileUpload2").click();
      //this.$refs.fileUploadBtn.click();
      console.log(document.getElementById("fileUpload2"));
    },
    chooseFiles3() {
      document.getElementById("fileUpload3").click();
      //this.$refs.fileUploadBtn.click();
      console.log(document.getElementById("fileUpload3"));
    },
    selecionaBanner(event) {
      console.log(event);
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      console.log(files[0]);
      this.files.set("file", event.target.files[0], event.target.files[0].name);
      this.banner = event.target.files[0].name;

      this.$vs.loading();
      service
        .upload("Upload", "Banner", this.files)
        .then((response) => {
          this.formCadastro.banner = response;
          console.log(response);
          this.$vs.loading.close();
          //this.onSubmit();
        })
        .catch((error) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: error,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    selecionaBannerMobile(event) {
      console.log(event);
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      console.log(files[0]);
      this.files.set("file", event.target.files[0], event.target.files[0].name);
      this.bannerMobile = event.target.files[0].name;

      this.$vs.loading();
      service
        .upload("Upload", "Banner", this.files)
        .then((response) => {
          this.formCadastro.bannerMobile = response;
          console.log(response);
          this.$vs.loading.close();
          //this.onSubmit();
        })
        .catch((error) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: error,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    preencheForm() {
      if (this.dados.idBanner) {
        this.formCadastro.idBanner = this.dados.idBanner;
        this.formCadastro.banner = this.dados.banner;
        this.formCadastro.bannerMobile = this.dados.bannerMobile;
        this.formCadastro.link = this.dados.link;
        this.formCadastro.ordenacao = this.dados.ordenacao;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
        this.banner = this.dados.banner;
        this.bannerMobile = this.dados.bannerMobile;
      } else {
        this.resetForm();
      }
    },

    onSubmit() {
      var action = "Atualizar/" + this.formCadastro.idBanner;
      var metodo = "put";
      var msgRetorno = "Dados Atualizados com sucesso";
      if (!this.formCadastro.idBanner) {
        action = "Adicionar";
        metodo = "post";
        msgRetorno = "Banner Adicionado com sucesso";
      }

      var objSend = { ...this.formCadastro };

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service[metodo]("Banners", action, objSend)
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: `Operação Realizada com sucesso`,
                color: "success",
              });
              this.$emit("concluido");
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: error,
                color: "danger",
              });
            });
        }
      });
    },

    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll("g", {}, `${model}/list`).then((res) => {
        res.data.forEach((element) => {
          if (element.deletedAt == null)
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
        console.log(this.regionais);
      });
    },
    resetForm() {
      this.formCadastro = {
        idBanner: null,
        status: true,
        banner: null,
        bannerMobile: null,
        link: "http://",
        ordenacao: null,
      };
    },
    onReset(evt) {
      this.$emit("cancel");

      this.resetForm();
    },
  },
  mounted() {
    this.preencheForm();
  },
  created() {
    this.$validator.localize("ptBr", locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    "v-select": vSelect,
  },
};
</script>
<!------------ END SCRIPT ------------>
<style scoped>
#fileInput {
  display: none;
}
.img label {
  width: 100%;
  font-weight: normal;
}

.img .containericone {
  text-align: center;
  border-radius: 10px;
  padding: 10px 20px;
  -webkit-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  width: min-content;
  margin-top: 25px;
  margin-left: 43%;
  border: 1px solid #ccc;
}

.img .icone {
  font-size: 50px;
  color: #333;
}

.input-group-color {
  display: flex !important;
  gap: 5px;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.color-picker {
  max-width: 2.5rem;
  height: 2.375rem;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 4px;
}
</style>
